import {Injectable} from '@angular/core';
import {Event, NavigationStart, Router} from '@angular/router';
import {BehaviorSubject} from 'rxjs';
import {map} from 'rxjs/operators';
import * as _ from 'lodash';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
    providedIn: 'root'
})
export class RouterDataService {

    routerData$; // DATA OBSERVABLE

    private data: any;
    private routeData: BehaviorSubject<any> = new BehaviorSubject(undefined);
    private tempData: any;

    constructor(private router: Router) {
        this.routerData$ = this.routeData.asObservable()
            .pipe( // Clone data and delete.
                untilDestroyed(this),
                map(ev => {
                    const r = _.cloneDeep(this.data);
                    this.data = undefined;
                    return r;
                }));

        this.router.events // Cleanup between routes
            .pipe(untilDestroyed(this))
            .subscribe((event: Event) => {
                if (event instanceof NavigationStart) {
                    this.data = this.tempData;
                    this.tempData = undefined;
                    this.routeData.next(undefined);
                }
            });
    }

    public setData = (state, data) => {
        if (this.router.routerState.snapshot.url === state) {
            this.data = data;
            this.routeData.next(undefined);
        } else {
            this.tempData = data;
        }
    };


    ngOnDestroy() {
    }
}
